import { format, parseISO } from "date-fns";
/**
 * A light wrapper around date-fns dateFormat to automate parsing date strings
 * from model objects
 * @param {String} dateString
 * @param {String} format the template to format the date
 * @returns A formatted string date representation
 */
export default function _dateFormat(dateString: string, dateFormat: string) {
  if (!dateString || dateString === "") {
    return "";
  }
  return format(parseISO(dateString), dateFormat);
}
